import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPipedriveIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.501 10.3833C10.501 11.9905 11.3163 13.7242 13.1104 13.7242C14.441 13.7242 15.7863 12.6855 15.7863 10.3598C15.7863 8.32072 14.7287 6.95186 13.1547 6.95186C11.8721 6.95186 10.501 7.85285 10.501 10.3833ZM13.7868 3.97461C17.0037 3.97461 19.1667 6.52246 19.1667 10.3151C19.1667 14.0481 16.8881 16.6543 13.6306 16.6543C12.0775 16.6543 11.0826 15.9891 10.5625 15.5076C10.5662 15.6218 10.5686 15.7496 10.5686 15.8861V20.9483H7.2361V7.46069C7.2361 7.2646 7.17339 7.20255 6.9791 7.20255H5.83301V4.24888H8.62936C9.91687 4.24888 10.2464 4.90414 10.3091 5.40925C10.8318 4.82348 11.9151 3.97461 13.7868 3.97461Z",
		fill: "#26292C"
	})]
});
const ForwardRef = forwardRef(SvgPipedriveIcon);
export { ForwardRef as ReactComponent };
